import React, { useState, useEffect } from 'react';
import { Menu, X, GraduationCap } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navigateTo = (path: string) => {
    setIsOpen(false);
    navigate(path);
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white shadow-lg py-3' 
          : 'bg-white/95 backdrop-blur-md shadow-md py-4'
      }`}
    >
      <div className="container mx-auto px-4 flex justify-between items-center">
        {/* الشعار */}
        <div 
          className="flex items-center cursor-pointer group"
          onClick={() => navigateTo('/')}
        >
          <div className="bg-blue-800 p-2 rounded-lg ml-3 group-hover:bg-blue-900 transition-colors">
            <GraduationCap className="h-6 w-6 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-blue-900 group-hover:text-blue-800 transition-colors">
            النداء
          </h1>
        </div>
        
        {/* القائمة الرئيسية - سطح المكتب */}
        <nav className="hidden md:flex items-center space-x-8">
          <button 
            onClick={() => navigateTo('/')}
            className="text-gray-700 hover:text-blue-800 font-medium transition-colors mr-16"
          >
            الرئيسية
          </button>
          <button 
            onClick={() => navigateTo('/pricing')}
            className="text-gray-700 hover:text-blue-800 font-medium transition-colors mr-16"
          >
            الاشتراك
          </button>
          <button 
            onClick={() => navigateTo('/join-us')}
            className="text-gray-700 hover:text-blue-800 font-medium transition-colors mr-16"
          >
            انضم إلينا
          </button>
          <a 
            href="https://wa.me/+9660590317360"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-blue-800 text-white px-6 py-2 rounded-lg hover:bg-blue-900 transition-colors font-medium"
          >
            اتصل بنا
          </a>
        </nav>
        
        {/* زر القائمة - الجوال */}
        <button 
          className="md:hidden text-gray-700 hover:text-blue-800 transition-colors"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="فتح القائمة"
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      
      {/* القائمة المنسدلة - الجوال */}
      {isOpen && (
        <div className="md:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="px-4 py-4 space-y-4">
            <button 
              onClick={() => navigateTo('/')}
              className="block w-full text-right text-gray-700 hover:text-blue-800 font-medium py-2 transition-colors"
            >
              الرئيسية
            </button>
            <button 
              onClick={() => navigateTo('/pricing')}
              className="block w-full text-right text-gray-700 hover:text-blue-800 font-medium py-2 transition-colors"
            >
              الاشتراك
            </button>
            <button 
              onClick={() => navigateTo('/join-us')}
              className="block w-full text-right text-gray-700 hover:text-blue-800 font-medium py-2 transition-colors"
            >
              انضم إلينا
            </button>
            <a 
              href="https://wa.me/+9660590317360"
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full bg-blue-800 text-white text-center px-4 py-3 rounded-lg hover:bg-blue-900 transition-colors font-medium"
            >
              اتصل بنا
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;